module.exports = __webpack_public_path__ + "static/img/product_1.0ab5475f.png";